module.exports = (($) => {
    class AjaxHandler {}
    $(document).ajaxError(function(event, jqxhr, settings, thrownError) {
        // not allowed
        if (jqxhr.status == 403) {
            // @todo display a "BOX" with this message
            // alert(jqxhr.responseJSON.message);

            if (jqxhr.responseJSON != undefined && jqxhr.responseJSON.message != undefined) {
                appMessageShow(jqxhr.responseJSON.message, 'danger');
            }

        }
        // not authenticated
        if (jqxhr.status == 401) {
            // redirect home to login form
            window.location.href = '/';
        }
        // not found
        if (jqxhr.status == 404) {
            // alert(jqxhr.responseJSON.message);
            if (jqxhr.responseJSON != undefined && jqxhr.responseJSON.message != undefined) {
                appMessageShow(jqxhr.responseJSON.message, 'danger');
            }
        }
        // error
        if (jqxhr.status == 500 || jqxhr.status == 503) {

            if (jqxhr.responseJSON != undefined && jqxhr.responseJSON.message != undefined) {
                // alert('JS Error: ' + jqxhr.responseJSON.message);
                appMessageShow('JS Error: ' + jqxhr.responseJSON.message, 'danger');
            } else {
                // alert(jqxhr.status + ' - Unerwartete Server Antwort / Verbindungsfehler - Bitte lade die Seite neu und versuche es noch einmal.');
                appMessageShow(jqxhr.status, 'danger');
            }
        }
    });

    $(document).ajaxComplete(function(event, request) {
        appMessage = request.getResponseHeader('app-message');
        if (appMessage) {
            appMessageShow(appMessage, (request.status == 422 ? 'danger' : 'success'));
        }
    });
    return AjaxHandler
})(jQuery)
